import i18n from "i18next";
import { AsyncButton, AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { faLayerGroup } from "@fortawesome/pro-regular-svg-icons";
import {
	ObjectConfigurationHistoryDataGrid,
	ObjectConfigurationHistoryDataGridProps,
} from "src/components/views/erp/configurator/objectConfigurationHistory/ObjectConfigurationHistoryDataGrid.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenConfigurationHistoryButtonProps
	extends Omit<AsyncButtonProps, "onClick">, ObjectConfigurationHistoryDataGridProps {}

export const OpenConfigurationHistoryButton = ({
	variant = "menu",
	objectType,
	objectId,
	refreshSourceView,
	restoreConfirmationMessage,
}: OpenConfigurationHistoryButtonProps) => {
	const { openDialog } = useGenericDialog();

	return (
		<AsyncButton
			label={i18n.t("configuration_history")}
			icon={faLayerGroup}
			variant={variant}
			onClick={() => {
				openDialog(() => ({
					title: i18n.t("configuration_history"),
					size: "xl",
					agentContext: {
						key: defineAgentUiContextKey("erp.configurator.objectConfigurationHistory.dialog"),
						data: { objectType, objectId },
						pathSegments: [i18n.t("configuration_history")],
					},
					content: (
						<ObjectConfigurationHistoryDataGrid
							objectType={objectType}
							objectId={objectId}
							refreshSourceView={refreshSourceView}
							restoreConfirmationMessage={restoreConfirmationMessage}
						/>
					),
				}));
			}}
		/>
	);
};
